<template>
    <div class="winter_page">
      <div class="first_page" v-if="page==1">
        <div class="first_page__bg_img">
          <img src="@/assets/winter/common/background.png">
        </div>
        <canvas id="canvas"></canvas>
        <div class="first_page__title">
          <img class="first_page__title_img" src="@/assets/winter/common/title.png">
          <p class="first_page__title_txt">축복이 될 말씀을 뽑아보세요!</p>
          <img class="first_page__btn" src="@/assets/winter/btn/choice.png" v-on:click="choiceVerse()">
        </div>
        <div class="first_page__logo">
          <img src="@/assets/winter/common/logo.png">
        </div>
    
      </div>
      <div class="second_page" v-if="page==2">
        <canvas id="canvas"></canvas>
        <div class="second_page__bg_img">
          <img src="@/assets/winter/common/background.png">
        </div>
        <div class="second_page__title">
          <img class="second_page__title_img" src="@/assets/winter/common/title2.png">
        </div>
        <div class="second_page__card">
          <img class="card" src="@/assets/winter/common/card.png">
          <p class="second_page__card_txt">성구를 뽑는<br> 중입니다.</p>
          <img class="logo" src="@/assets/winter/common/logo2.png">
        </div>
      </div>
      <div class="third_page" v-if="page==3">
        <div class="third_page__transform" :class="scroll?'on':''">
        <canvas id="canvas"></canvas>

          <div class="capture_area">
            <div class="capture_area__back_img">
              <img src="@/assets/winter/common/background2.png">
            </div>
            <div class="capture_area__title">
              <img src="@/assets/winter/common/title2.png">
            </div>
            <div class="capture_area__card">
                <img class="card" src="@/assets/winter/common/card.png">
                <div class="capture_area__card_txt_area">
                  <p class="capture_area__card_txt" >{{print_verse.verse}}</p>
                  <p class="capture_area__card_verse">{{print_verse.chapter}}</p>
                </div>
                <img class="logo" src="@/assets/winter/common/logo2.png">
            </div>
            <div class="capture_area__arrow" v-on:click="scrollClick()">
              <img src="@/assets/winter/common/click.png">
            </div>
          </div>
          <div class="btn_area">
            <div class="btn_area__back_img">
              <img src="@/assets/winter/common/background.png">
            </div>
            <div class="btn_area__title">
              <img src="@/assets/winter/common/title.png">
            </div>
            <ul class="btn_area__list">
              <li class="btn_area__item" v-on:click="choiceVerse()">
                <img src="@/assets/winter/btn/reset.png">
              </li>
              <li class="btn_area__item" v-on:click="shareClick()">
                <img src="@/assets/winter/btn/copy.png">
              </li>
              <li class="btn_area__item" v-on:click="imgSave()">
                <img src="@/assets/winter/btn/img_save.png">
              </li>
              <li class="btn_area__item" v-on:click="gotoAnother()">
                <img src="@/assets/winter/btn/others.png">
              </li>
              <li class="btn_area__item" v-on:click="gotoWs()">
                <img src="@/assets/winter/btn/ws.png">
              </li>
              <li class="btn_area__item" v-on:click="scrollClick()">
                <img src="@/assets/winter/btn/return.png">
              </li>
            </ul>
            <div class="btn_area__logo">
              <img src="@/assets/winter/common/logo.png">
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import $ from 'jquery';
export default {
    props : ['verse','scroll','page','print_verse'
            ,'goto_choice','scroll_click','share_fun','goto_another','goto_ws','image_save',
            'date'],
    methods: {
        choiceVerse(){
            this.goto_choice();
        },
        scrollClick(){
            this.scroll_click();
        },
        shareClick(){
            this.share_fun();
        },
        gotoAnother(){
            this.goto_another();
        },
        gotoWs(){
            this.goto_ws();
        },
        imgSave(){
            this.image_save();
        },
        draw(){
          this.ctx.clearRect(0, 0, this.W, this.H);
          
          this.ctx.fillStyle = "rgba(255, 255, 255, 0.8)";
          this.ctx.beginPath();
          for(var i = 0; i < this.mp; i++){
            var p = this.particles[i];
            this.ctx.moveTo(p.x, p.y);
            this.ctx.arc(p.x, p.y, p.r, 0, Math.PI*2, true);
          }
          this.ctx.fill();
          this.update();
        },
        update(){
          this.angle += 0.01;
          for(var i = 0; i < this.mp; i++){
            var p = this.particles[i];
            //Updating X and Y coordinates
            //We will add 1 to the cos function to prevent negative values which will lead flakes to move upwards
            //Every particle has its own density which can be used to make the downward movement different for each flake
            //Lets make it more random by adding in the radius
            p.y += Math.cos(this.angle+p.d) + 1 + p.r/2;
            p.x += Math.sin(this.angle) * 2;
            
            //Sending flakes back from the top when it exits
            //Lets make it a bit more organic and let flakes enter from the left and right also.
            if(p.x > this.W+5 || p.x < -5 || p.y > this.H){
              if(i%3 > 0){
                this.particles[i] = {x: Math.random()*this.W, y: -10, r: p.r, d: p.d};
              }else{
                //If the flake is exitting from the right
                if(Math.sin(this.angle) > 0){
                  //Enter from the left
                  this.particles[i] = {x: -5, y: Math.random()*this.H, r: p.r, d: p.d};
                }else{
                  //Enter from the right
                  this.particles[i] = {x: this.W+5, y: Math.random()*this.H, r: p.r, d: p.d};
                }
              }
            }
          }
        },
        snowInit(){
          this.canvas = document.getElementById("canvas");
          this.ctx = this.canvas.getContext("2d");
          
          //canvas dimensions
          this.W = $('.winter_page').width();
          this.H = $('.winter_page').height();

          this.canvas.width = this.W;//this.X
          this.canvas.height = this.H;//this.Y
          for(var i = 0; i < this.mp; i++){
            this.particles.push({
              x: Math.random()*this.W, //x-coordinate
              y: Math.random()*this.H, //y-coordinate
              r: Math.random()*4+1, //radius
              d: Math.random()*this.mp //density
            })
          }
        }
    },
    data() {
      return {
        canvas: "",
        ctx: "",
        W: "",
        H: "",
        mp: 50,
        particles: [],
        angle: 0,
      }
    },
    mounted(){
      let date_str = this.date;
      if(date_str==12 || date_str==1 || date_str==2){
        setTimeout(() => {
          this.snowInit();
        }, 500);
        setInterval(this.draw, 33);
      }
    }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/scss/winter.scss';
</style>
